import { Box, TextField, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import DocumentUpload from "components/UI/documentUpload/DocumentUpload";
import AdvancedInputField from "components/UI/AdvancedInputField/AdvancedInputField";

const NumberField = ({
  options,
  submittedAnswer,
  responseAnswer,
  isFrom,
  handleQuesAnswer,
  questionType,
  event,
  comment,
  linkageAnswer,
  calculation,
  question,
  hasAttachedDocument,
}) => {
  const [value, setValue] = useState("");
  const [commentBox, setCommentBox] = useState("");
  const [attachDocument, setAttachDocument] = useState(null);

  const handleCommonChange = (field, val) => {
    const updatedValue = field === "value" ? val.replace(/\D/g, "") : val; // strip non-numeric if numeric field

    if (field === "value") setValue(updatedValue);
    if (field === "comment") setCommentBox(updatedValue);
    if (field === "document") setAttachDocument(val);

    if (isFrom === "taskSection") {
      const obj = {
        value: field === "value" ? updatedValue : value,
        weightage: 1,
        comment: field === "comment" ? updatedValue : commentBox,
        supporting_document:
          field === "document" && val === null ? val : attachDocument,
        document: field === "document" ? val : attachDocument,
        documentMetaData:
          field === "document"
            ? {
                ques_id: question?._id,
                name: val?.name,
                is_supporting_document: true,
                type: val?.type,
              }
            : null,
      };
      handleQuesAnswer({ obj, realQuestion: question });
    }
  };

  useEffect(() => {
    if (!!calculation?.custom_calculation_logic) {
      setValue(calculation?.resolved_custom_calculation_logic);
    }
  }, [calculation]);

  useEffect(() => {
    if (submittedAnswer && submittedAnswer?.length > 0) {
      setValue(submittedAnswer?.[0]?.value);
      setCommentBox(submittedAnswer?.[0]?.comment);
      setAttachDocument(submittedAnswer[0]?.supporting_document || null);
    }
  }, []);

  const placeholderSize = {
    inputProps: {
      sx: { fontSize: "14px" },
    },
  };

  const labelSize = {
    style: { fontSize: "14px" },
  };

  return (
    <Box
      mt={2}
      sx={{
        pointerEvents: isFrom === "publishedSurvey" ? "none" : "auto",
      }}
    >
      <TextField
        style={{ pointerEvents: event }}
        disabled={!!calculation?.custom_calculation_logic}
        label={"Numeric Value"}
        variant="outlined"
        value={value}
        size="small"
        fullWidth
        onChange={(e) => handleCommonChange("value", e.target.value)}
        inputProps={{
          inputMode: "numeric",
          pattern: "[0-9]*",
        }}
        InputLabelProps={labelSize}
        InputProps={placeholderSize}
      />
      <Box mt={2}>
        {!!calculation?.custom_calculation_logic &&
          calculation?.resolved_custom_calculation_logic && (
            <Typography>
              Answer to this question has already been auto calculated.
            </Typography>
          )}
        {!!calculation?.custom_calculation_logic &&
          !calculation?.resolved_custom_calculation_logic && (
            <Typography>
              Answer to this question will be calculated automatically*
            </Typography>
          )}
      </Box>
      {comment && (
        <Box style={{ pointerEvents: event, marginTop: "10px" }}>
          <AdvancedInputField
            name="comment"
            data={commentBox}
            placeholder="Contributor's comment"
            handleChange={({ name, value }) => {
              handleCommonChange(name, value);
            }}
          />
        </Box>
      )}
      {hasAttachedDocument && (
        <Box style={{ pointerEvents: event, marginTop: "10px" }}>
          <DocumentUpload
            value={attachDocument}
            isFrom="surveyTask"
            handleChange={handleCommonChange}
            question={"document"}
          />
        </Box>
      )}
    </Box>
  );
};

export default NumberField;
